// extracted by mini-css-extract-plugin
export default {"iframe":"PenaltyCommentModal_iframe__iVU71","iframeWrapper":"PenaltyCommentModal_iframeWrapper__kdNVU"};